import React, { useState, useEffect } from 'react';
import { Card, Col, Row, Button, Spinner, Modal } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import useFormGenerator from '../../common/FormUtils';
import useHeaderGenerator from '../../common/functions/useHeaderGenerator';
import useButtonsGenerator from '../../common/functions/useButtonsGenerator';
import { useParams } from 'react-router-dom';
import FormModal from '../../common/FormModal';
import ProgramService from './ProgramService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRobot } from '@fortawesome/free-solid-svg-icons';
import schema from './jsonSchema';
import { Badge } from 'react-bootstrap';
import ImportFromPDF from './ImportFromPDF';
import is from 'is_js';
const jsonSchema = schema;


const GenerateProgramAI = () => {
  const { identifier } = useParams();
  const [data, setData] = useState();
  const [modalShow, setModalShow] = useState(false);
  const [showForm, setShowForm] = useState(true);
  const [isLoadingProgramFromAI, setIsLoadingProgramFromAI] = useState(false);
  const [excercises, setExcercises] = useState('');
  const convertToOptions = text => {
    const arrayOfInterests = text.split(',').map(i => i.trim());
    if (text) {
      return arrayOfInterests.map(i => ({ value: i, label: i }));
    }
    return [];
  };
  useEffect(() => {
    if (undefined !== identifier) {
      ProgramService.retrieveProgram(identifier)
        .then(data => {
          console.log('Retrieved Program:', data);
          const updatedData = {
            ...data,
            tags: data.tags ? convertToOptions(data.tags) : [],
            exercises: data.exercises ? convertToOptions(data.exercises) : []
          };
          setData(updatedData);
        })
        .catch(error => console.log(error));
    }
  }, [identifier]);
  const handleAddProgram = () => {
    setIsLoadingProgramFromAI(true);
    setData(null); // Clear previous data
    ProgramService.generateProgramFromAI(excercises)
      .then(response => {
        console.log('Program generated from AI:', response);
        /*const updatedData = {
          ...response,
          description: response.program || '',
          tags: response.tags ? convertToOptions(response.tags) : [],
          exercises: response.exercises
            ? convertToOptions(response.exercises)
            : []
        };*/
        const updatedData = response[0];
        console.log('Updated Data to be set:', updatedData);
        setData(updatedData);
        setShowForm(true);
      })
      .catch(error => {
        console.log('Error generating program from AI:', error);
        setIsLoadingProgramFromAI(false);
      })
      .finally(() => {
        setIsLoadingProgramFromAI(false);
      });
  };
  const handleProgramFormSubmit = formData => {
    const updatedData = {
      ...formData,
      type: formData.type.value };
    ProgramService.saveProgram(updatedData)
      .then(response => {
        console.log(response);
        setModalShow(true);
      })
      .catch(error => console.log(error));
  };

  const buttonsConf = [
    {
      name: 'Save Program',
      type: 'submit',
      variant: 'info',
      onClick: () => {
        console.log('Save Program');
      }
    },
    {
      name: 'Cancel',
      type: 'button',
      variant: 'secondary',
      onClick: () => {
        console.log('Cancel');
        setShowForm(false);
      }
    }
  ];
  const headerGenerated = useHeaderGenerator(
    'Generate Program from AI',
    'Fill in the details of your new Program',
    []
  );
  return (
    <>
      {headerGenerated}
      {modalShow && (
        <FormModal
          message={'Program  has been updated!'}
          modalShow={modalShow}
          setModalShow={setModalShow}
          redirectUrl="/app/wod/programs"
        />
      )}
      {identifier === undefined && (<Card className="mb-3">
        <Card.Body>
          <Row>
            <Col lg={12}>
              <Form.Control
                type="text"
                placeholder="Excercise1, Excercise2, etc..."
                onChange={e => {
                  setExcercises(e.target.value);
                  console.log('Search for:', e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row className="mt-3">
            <Col lg={12}>
              <Button
                variant="success"
                type="button"
                onClick={handleAddProgram}
                className="px-4 mx-0 btn btn-sm"
                disabled={isLoadingProgramFromAI}
                icon={faRobot}
              >
                {<FontAwesomeIcon icon={faRobot} className="me-2" />}
                {isLoadingProgramFromAI ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    Loading...
                  </>
                ) : (
                  'Generate Program'
                )}
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>)}
      {showForm && (
        <Card>
          <Card.Body>
            {data || undefined === identifier ? (
              // Pass data to the form generator hook
              <FormGeneratorWithData
                data={data}
                buttonsConf={buttonsConf}
                onSubmit={handleProgramFormSubmit}
              />
            ) : (
              <p>Loading...</p>
            )}
          </Card.Body>
        </Card>
      )}
    </>
  );
};
const FormGeneratorWithData = ({ data, buttonsConf, onSubmit }) => {
  const [validated, setValidated] = useState(false);
  const buttonsGenerated = useButtonsGenerator(buttonsConf);
  // Use the useFormGenerator hook with the provided data
  const { formFields, handleSubmit, handleChange } = useFormGenerator(
    jsonSchema,
    onSubmit,
    data,
    setValidated
  );

  // Render your form using the formFields and event handlers
  return (
    <Form
      className="mb-2"
      noValidate
      validated={validated}
      onSubmit={handleSubmit}
    >
      {formFields}
      <Card.Footer>{buttonsGenerated}</Card.Footer>
    </Form>
  );
};
export default GenerateProgramAI;
